module.exports = __webpack_public_path__ + "img/lb5.0f12def3.svg";